// src/api/auth.js
// All authentication HTTP calls live here, plus the request interceptor that
// attaches the stored token to every outgoing API request.
// Components and the AuthProvider import these functions; they never call axios directly.
//
// Paths are relative ("/api/auth"), forwarded to the backend by setupProxy.js in
// development and served from the same origin in production, like the other api files.
//
// Each function returns response.data (the body). Errors propagate to the caller.

import axios from "axios";

const BASE = "/api/auth";

// localStorage key for the access token. Exported so the AuthProvider writes and
// clears the same key the interceptor reads.
export const TOKEN_KEY = "token";

// Register a request interceptor on the shared axios instance. On every outgoing
// request it reads the current token from localStorage and, if present, sets it as
// a Bearer token in the Authorization header. Because api/blogs.js and api/users.js
// import this same default axios, all API calls are covered without touching them.
// Reading localStorage per request (rather than caching) keeps the header current:
// it appears right after login and disappears after logout.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// POST /api/auth/create-account, register a new account.
// data: { username, email, password } (name optional).
// Returns { success, data: { token, user }, message }.
export async function createAccount(data) {
  const response = await axios.post(`${BASE}/create-account`, data);
  return response.data;
}

// POST /api/auth/login, validate credentials and receive a token plus user.
// credentials: { username, password }.
// Returns { success, data: { token, user }, message }.
export async function login(credentials) {
  const response = await axios.post(`${BASE}/login`, credentials);
  return response.data;
}
